import React, {useContext} from 'react';
import {Navigate} from 'react-router-dom';
import {AppContext} from '../context/appContext';

export const PublicRoute = ({children}) => {

    const {user} = useContext(AppContext);
    const lastPath = localStorage.getItem('lastPath') === null ? '/home' : localStorage.getItem('lastPath');
    return user.logged
        ? <Navigate to={lastPath}/>
        : children
}
